import { REQUEST_REPORT_UPDATE } from 'constants/routePaths';


import * as React from 'react';

import { EditCalendar } from '@mui/icons-material';
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import selectTokenRoles from 'selectors/sessionTokenRoles';
import { hasSuperAdminRole } from 'utils/roleUtils';

interface Props {
  handleClose: () => void;
  report: reports.AllReportsQueryRow;
  setShowUpdateReportDisabledModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const UpdateReportMenuItem: React.FC<Props> = ({ 
  handleClose, 
  report,
  setShowUpdateReportDisabledModal 
}) => {
  const { t } = useTranslation();
  const isSuperAdmin = hasSuperAdminRole(useSelector(selectTokenRoles));

  const menuItemProps = isSuperAdmin
    ? { component: Link, to: { pathname: REQUEST_REPORT_UPDATE, state: { templateReport: report, initStep: '2' } } }
    : {};

  return (
    <MenuItem
      {...menuItemProps}
      onClick={() => {
        if (!isSuperAdmin) setShowUpdateReportDisabledModal(true);
        handleClose();
      }}
    >
      <ListItemIcon>
        <EditCalendar fontSize="small" color="primary" />
      </ListItemIcon>
      <ListItemText primary={t('reportsQa.menu.updateReport')} />
    </MenuItem>
  );
};

export default UpdateReportMenuItem;
